import React from 'react';
import { Spin, Row, Col, Typography, Button } from 'antd';
import { IPlanOwner } from '../../types/planOwner';

const { Text } = Typography;

interface PlanOwnerInfoProps {
  loading: boolean;
  planOwner: IPlanOwner;
}

export const PlanOwnerInfo = ({ loading, planOwner }: PlanOwnerInfoProps) => {
  if (loading) return <Spin size="small" />;
  if (!planOwner) return 'N/A';

  return (
    <Row gutter={[8, 8]}>
      <Col span={24}>
        <Text strong>Name: </Text> {planOwner.name}
      </Col>
      {planOwner.ceo && (
        <Col span={24}>
          <Text strong>CEO: </Text> {planOwner.ceo}
        </Col>
      )}
      {planOwner.phone && (
        <Col span={24}>
          <Text strong>Phone: </Text>
          <Button type="link" href={`tel:${planOwner.phone}`} style={{ padding: 0 }}>
            {planOwner.phone}
          </Button>
        </Col>
      )}
      {planOwner.email && (
        <Col span={24}>
          <Text strong>Email: </Text>
          <Button type="link" href={`mailto:${planOwner.email}`} style={{ padding: 0 }}>
            {planOwner.email}
          </Button>
        </Col>
      )}
      {planOwner.webSite && (
        <Col span={24}>
          <Text strong>Website: </Text>
          <Button
            type="link"
            onClick={() => window.open(planOwner.webSite, '_blank')}
            style={{ padding: 0 }}>
            {planOwner.webSite}
          </Button>
        </Col>
      )}
    </Row>
  );
};
